var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-days"},_vm._l((_vm.weekdays),function(weekday){return _c('li',{key:weekday},[_c('span',{staticClass:"sm-text"},[_vm._v(_vm._s(weekday))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }